import { Link } from "react-router-dom";
import { useLang } from "@/i18n/LangContext";

export function useFormHelpers() {
  const { t, to, lang } = useLang();
  const c = t.common;
  const isEmail = (v) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);
  const errorMessage = (e) => (e?.response?.status === 429 ? c.tooMany : c.error);
  return { c, to, lang, isEmail, errorMessage };
}

export function Field({ label, error, children, id }) {
  return (
    <div>
      <label className="label" htmlFor={id}>{label}</label>
      {children}
      {error && <p className="mt-1.5 text-xs font-medium text-rose-600" data-testid={`${id}-error`}>{error}</p>}
    </div>
  );
}

export function Consent({ checked, onChange, error, id }) {
  const { t, to } = useLang();
  return (
    <div>
      <label className="flex items-start gap-3 text-sm text-slate-600">
        <input type="checkbox" checked={checked} onChange={(e) => onChange(e.target.checked)} className="mt-1 h-4 w-4 rounded border-slate-300 accent-teal-600" data-testid={`${id}-consent-checkbox`} />
        <span>{t.common.consent} <Link to={to("privacy")} className="underline decoration-teal-500 underline-offset-2 hover:text-teal-700">{t.common.privacyLink}</Link>.</span>
      </label>
      {error && <p className="mt-1.5 text-xs font-medium text-rose-600" data-testid={`${id}-consent-error`}>{error}</p>}
    </div>
  );
}

export function SuccessBox({ reference, id, onReset }) {
  const { t } = useLang();
  return (
    <div className="rounded-3xl border border-teal-200 bg-teal-50 p-8 text-center" data-testid={`${id}-success`}>
      <p className="font-display text-xl font-bold text-teal-900">{t.common.success}</p>
      <p className="mt-2 font-mono text-sm text-teal-700">{t.common.reference} : <span data-testid={`${id}-reference`}>{reference}</span></p>
      <button type="button" onClick={onReset} className="btn-secondary mt-6 !py-2.5" data-testid={`${id}-reset-button`}>OK</button>
    </div>
  );
}
